<template>
  <div class="course-detail-page">
    <div class="course-header">
      <div class="course-info">
        <div class="course-initial">
          <div>
            <h1>{{ course.name }}</h1>
            <p>{{ course.description }}</p>
          </div>
          <div class="course-image">
            <img :src="course.course_image" alt="Course Image" />
          </div>
        </div>
        <div class="price" v-if="course.payment_option">
          <h2 v-if="course.payment_option != 'free'">{{ course.price }} Azadi Coin (AC)</h2>
          <h2 v-else>Free</h2>
          <span v-if="course.payment_option != 'free'" class="price-label">Price</span>
          <span v-else class="price-label"></span>
          <router-link  v-if="course.payment_option != 'free'" :to="'/checkout/'+$route.params.id"
            ><button class="enroll-btn">Enroll Now</button></router-link
          >
          <router-link v-else :to="'/free-course/'+$route.params.id"
            ><button class="enroll-btn">Start Now</button></router-link
          >
        </div>
        <div class="course-details">
          <div>
            <div class="table-head">{{ course.duration }} minutes</div>
            <span>Duration</span>
          </div>
          <div>
            <div class="table-head">{{ course.certification_validity }}</div>
            <span>Certification Validity</span>
          </div>
          <div>
            <div class="table-head">{{ course.exam_type }}</div>
            <span>Exam</span>
          </div>
          <div>
            <div class="table-head">{{ course.access_mode }}</div>
            <span>Access Mode</span>
          </div>
          <div>
            <div class="table-head">{{ course.level }}</div>
            <span>Level</span>
          </div>
        </div>
      </div>
    </div>

    <div class="modules-section">
      <h4>Modules of the Tutorial</h4>
      <div
        v-for="(module, index) in course.module"
        :key="index"
        class="module"
      >
        <button class="module-toggle" @click="toggleModule(index)">
          {{ module.name }}
          <span v-if="activeModule === index">▲</span>
          <span v-else>▼</span>
        </button>
        <ul v-show="activeModule === index" class="lessons-list">
          <li
            v-for="(lesson, lessonIndex) in module.lesson"
            :key="lessonIndex"
          >
            {{ lesson.name }}
          </li>
        </ul>
      </div>
      <p class="note">
        <!-- **note for the development: ability to view the name of the modules and
        lessons before the registration, but no access to content. -->
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      activeModule: null,
      lessons: [
              "Smart Contracts Overview",
              "Real-world Use Cases",
              "Ethereum and Solidity Basics",
            ],
      course: { },
    };
  },
  mounted() {
    this.getCourseDetails();
  },
  methods: {
    toggleModule(index) {
      this.activeModule = this.activeModule === index ? null : index;
    },
    async getCourseDetails() {
      try {
        const response = await axios.get("courses/view/"+this.$route.params.id);
        this.course = response.data.data;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
.course-detail-page {
  text-align: center;
  font-family: 'GothicB';
}

.course-initial {
  display: flex;
  gap: 2rem;
}

.course-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 3rem 1.5rem;
  max-width: 60rem;
  margin: 0 auto;
}

.course-info {
  text-align: left;
  flex: 1;
}

.course-info h1 {
  font-size: 2rem;
}

.course-info p {
  margin: 1rem 0;
  font-size: 0.95rem;
  color: #fff;
  font-family: 'Gothic';
}

.price {
  margin: 1.5rem 0;
}

.price h2 {
  color: #f0c57a;
}

.enroll-btn {
  padding: 0.6rem 2rem;
  background-color: #f0c57a;
  color: #000;
  border: 1px solid #f0ba7c;
  outline: none;
  border-radius: 0.5rem;
  font-weight: 700;
  font-size: 1rem;
  padding: 0.6rem 2rem;
  font-family: 'Gothic';
}

.enroll-btn:hover {
  background-color: #e0b56a;
}

.course-details {
  display: flex;
  gap: 1.5rem;
  margin: 2rem 0 0;
  flex-wrap: wrap;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  border-radius: 0.4rem;
}

.course-details > div {
  text-align: left;
  padding: 1rem 0;
  flex: 1;
}

.course-details > div:not(:last-child) {
  border-right: 1px solid #ccc;
  padding-right: 1rem;
}

.course-image img {
  max-width: 350px;
  border-radius: 10px;
}

.modules-section {
  text-align: left;
  max-width: 60rem;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.price-label {
  opacity: 0.5;
  font-size: 0.8rem;
  display: block;
  margin-bottom: 1.5rem;
}

.modules-section h4 {
  margin: 2rem 0 1rem;
  color: #fff;
}

.module {
  margin-bottom: 1rem;
}

.module-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  border: 1px solid #ccc;
  padding: 1rem;
  width: 100%;
  text-align: left;
  cursor: pointer;
  font-weight: bold;
  font-family: 'GothicB';
  border-radius: 4px;
  font-size: 1rem;
  color: #fff;
}

.lessons-list {
  margin-top: 0.5rem;
  padding-left: 1.5rem;
  list-style: disc;
}

.note {
  color: red;
  margin: 2rem 0;
}

.table-head {
  font-size: 1rem;
  display: block;
  margin-bottom: 0.5rem;
  font-family: 'Gothic';
  text-transform: capitalize;
}
</style>
